var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.updateVerifiShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "content", attrs: { id: "verificationUpdate" } },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.$t("language.twoStepverification.twoStep")) +
                  "\n                 "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.closePage()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "set-body-content" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    height: "calc(100% - 50Px)",
                    float: "left",
                    lineHeight: "20Px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "left",
                        height: "40Px",
                        width: "100%",
                        fontSize: "14Px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { float: "left", width: "195Px" } },
                        [
                          _c("span", { staticStyle: { color: "#6f7886" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("language.twoStepverification.twoStepis")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.verificationStatus == "on"
                            ? _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.twoStepverification.on")
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.verificationStatus == "off"
                            ? _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("language.twoStepverification.off")
                                  )
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("mySwitch", {
                        staticStyle: {
                          float: "left",
                          height: "20px",
                          display: "flex",
                          "align-items": "center"
                        },
                        on: { input: _vm.changeData },
                        model: {
                          value: _vm.verificationStatus,
                          callback: function($$v) {
                            _vm.verificationStatus = $$v
                          },
                          expression: "verificationStatus"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        float: "left",
                        fontSize: "14Px",
                        height: "30Px",
                        color: "#6f7886"
                      }
                    },
                    [
                      _vm._v(
                        " \n                        " +
                          _vm._s(
                            _vm.$t("language.twoStepverification.verifyIdenti")
                          ) +
                          ":\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.emialShow
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            float: "left",
                            fontSize: "14Px",
                            height: "35Px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#6f7886",
                                float: "left",
                                width: "100Px"
                              },
                              style: { width: _vm.getEmailWidth() }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.twoStepverification.emailCode"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                marginLeft: "50Px",
                                width: "200Px",
                                textAlign: "left",
                                float: "left"
                              },
                              style: { marginLeft: _vm.getMarginLeft() }
                            },
                            [_c("b", [_vm._v(_vm._s(_vm.emialValue))])]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _c("div", {
                              staticClass: "vertifiname-edit",
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "2Px"
                              },
                              attrs: { title: "Edit" },
                              on: {
                                click: function($event) {
                                  return _vm.edit("email")
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "delete",
                            staticStyle: { float: "right", cursor: "pointer" },
                            attrs: { title: "Remove" },
                            on: {
                              click: function($event) {
                                return _vm.toRemove("email")
                              }
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.txtShow
                    ? _c(
                        "div",
                        {
                          ref: "phoneTxt",
                          staticStyle: {
                            width: "100%",
                            float: "left",
                            fontSize: "14Px",
                            height: "35Px"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#6f7886",
                                float: "left",
                                width: "100Px"
                              },
                              style: { width: _vm.getEmailWidth() }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.twoStepverification.TextCode"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                marginLeft: "50Px",
                                width: "200Px",
                                textAlign: "left",
                                float: "left"
                              },
                              style: { marginLeft: _vm.getMarginLeft() }
                            },
                            [_c("b", [_vm._v(_vm._s(_vm.phoneValue))])]
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _c("div", {
                              staticClass: "vertifiname-edit",
                              staticStyle: {
                                float: "left",
                                position: "relative",
                                top: "2Px"
                              },
                              attrs: { title: "Edit" },
                              on: {
                                click: function($event) {
                                  return _vm.edit("phone")
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "delete",
                            staticStyle: { float: "right", cursor: "pointer" },
                            attrs: { title: "Remove" },
                            on: {
                              click: function($event) {
                                return _vm.toRemove("phone")
                              }
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "bottomPosition",
                      staticStyle: { position: "relative" }
                    },
                    [
                      !(_vm.emialShow && _vm.txtShow)
                        ? _c(
                            "div",
                            {
                              staticClass: "remove-all",
                              on: {
                                click: function($event) {
                                  return _vm.addWay()
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { cursor: "pointer" } },
                                [
                                  _vm._v(
                                    "+" +
                                      _vm._s(
                                        _vm.$t(
                                          "language.twoStepverification.addWayVerify"
                                        )
                                      )
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "remove-all",
                  on: {
                    click: function($event) {
                      return _vm.removeAll()
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { cursor: "pointer" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("language.twoStepverification.removeTrusted")
                      )
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { width: "100%", height: "30Px", float: "left" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#2e79f6",
                        float: "left",
                        lineHeight: "30Px",
                        cursor: "pointer"
                      },
                      on: {
                        click: function($event) {
                          return _vm.replacecode()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("language.twoStepverification.getRecode"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticStyle: { float: "right", width: "110Px" },
                      on: {
                        click: function($event) {
                          return _vm.closePage()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                  )
                ]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6e11e98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6e11e98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/update_verification_popup.vue
// module id = null
// module chunks = 